import React, { useContext, useState } from 'react'
import { AppContext } from './App'
import ActionsBar from './components/actionsBar'
import FeatureDetails from './components/featureDetails'
import SearchBar from './components/searchBar'
import Credits from './layouts/credits'
import CategorySelector from './layouts/categorySelector'
import FilterSelector from './layouts/filterSelector'


const Controls = () => {
  const {
    lang,
    unsetFeature,
    currentFeature,
    getTranslatedUiLabel,
    toggleLanguage,
    setSearchKeyword,
    filters,
  } = useContext(AppContext)

  const [showCredits, setShowCredits] = useState()
  const [showFilters, setShowFilters] = useState()
  const [showSearch, setShowSearch] = useState()

  function toggleFilters() {
    unsetFeature()
    setSearchKeyword("")
    setShowCredits(false)
    setShowSearch(false)
    setShowFilters(curr => !curr)
  }

  function toggleSearch() {
    unsetFeature()
    setSearchKeyword("")
    setShowCredits(false)
    setShowFilters(false)
    setShowSearch(curr => !curr)
  }

  function toggleCredits() {
    unsetFeature()
    setSearchKeyword("")
    setShowFilters(false)
    setShowSearch(false)
    setShowCredits(curr => !curr)
  }

  function renderControls() {
    if (showCredits) {
      return <Credits closeAction={() => setShowCredits(false)} />
    }
    else if (currentFeature) {
      return <FeatureDetails
        feature={currentFeature}
        getTranslatedUiLabel={getTranslatedUiLabel}
        closeAction={unsetFeature}
      />
    }
    else {
      return <div className="App-controls-container">
        { showSearch && <SearchBar closeAction={toggleSearch} /> }
        { showFilters && <FilterSelector closeAction={() => setShowFilters(false)} /> }
        { !currentFeature && <CategorySelector /> }
      </div>
    }
  }

  return <div className="App-controls">
    { !showSearch && <ActionsBar
      lang={lang}
      toggleFilters={toggleFilters}
      toggleLang={toggleLanguage}
      toggleCredits={toggleCredits}
      toggleSearch={toggleSearch}
      filtersActive={showFilters}
      creditsActive={showCredits}
      searchActive={showSearch}
      showFilterIndicator={filters && filters.filter(f => f.selected).length > 0}
    /> }
    <div className="App-controls-scrollable hide-scrollbar">
      {renderControls()}
    </div>
  </div>
}

export default Controls